@if (galleryPermissions().can_edit || items?.length) {
  <input
    type="file"
    id="{{ uploadIdPrefix }}asset-upload"
    #upload
    class="hidden-input"
    (change)="uploadAssetEvent($event.target)"
    accept="*"
    multiple
  />
  <app-drop
    (onFileDrop)="uploadAssets($event)"
    (onFileUrlDrop)="uploadAssets($event)"
    [hoverStyle]="'white'"
    [disable]="!galleryPermissions().can_edit"
    [darkBackground]="darkBackground()"
    [default]="sectionIndex() === 0"
  >
    <app-section-container
      #sectionContainer
      [index]="sectionIndex()"
      [gallery]="gallery()"
      [section]="section()"
      [sections]="sections()"
      [galleryPermissions]="galleryPermissions()"
      [darkBackground]="darkBackground()"
      [outsideActions]="true"
      [insideActions]="true"
      [noMaxWidth]="true"
      [theme]="theme()"
      sectionContentInnerPosition="relative"
      (mousemove)="mouseMove($event)"
      (mouseup)="mouseUp()"
      (addSection)="addSection.emit($event)"
    >
      @if (isDesktop) {
        <ng-container sectionActionsOutside>
          <div class="spaced-button-group-item">
            <app-context-menu
              [options]="{ width: '240px', noSpacing: true }"
              [position]="'right-out'"
              [verticalPosition]="'auto-in'"
              #sourceMenu
              contextHoverIdentifier="section-{{ section().id }}"
            >
              <button
                appButton
                name="select-source"
                location="assets-section"
                [iconButton]="true"
                height="1"
                shape="round"
                color="simple"
                appTooltip="Upload Media"
                toolTipOrigin="left"
                contextButton
              >
                <app-svg src="/assets/icons/upload.svg"></app-svg>
              </button>

              <div contextContent class="button-menu">
                <app-upload-source-menu
                  [uploadIdPrefix]="uploadIdPrefix"
                  [sectionId]="section().id"
                  (onClose)="sourceMenu.close()"
                  (onUpload)="uploadAssets($event)"
                ></app-upload-source-menu>
              </div>
            </app-context-menu>
          </div>
        </ng-container>
      }

      <ng-container sectionActionsInside>
        @if (isDesktop) {
          <div class="spaced-button-group-item">
            <app-context-menu
              [options]="{ width: '320px', noSpacing: true }"
              [position]="'right-out'"
              [verticalPosition]="'auto-in'"
              #menu
              contextHoverIdentifier="section-{{ section().id }}"
            >
              <button
                appButton
                name="settings"
                location="assets-section"
                [iconButton]="true"
                height="1"
                shape="round"
                contextButton
                appTooltip="Section Settings"
                toolTipOrigin="left"
                color="simple"
              >
                <app-svg src="/assets/icons/mixer.svg"></app-svg>
              </button>
              <div contextContent>
                @if (menu.isOpen()) {
                  <app-assets-section-menu
                    [section]="section()"
                    [gallery]="gallery()"
                    [theme]="theme()"
                    (onUpdateLayout)="calculateAllItemPositions()"
                    (onBeforeChange)="beforeSettingsChange()"
                  >
                  </app-assets-section-menu>
                }
              </div>
            </app-context-menu>
            <app-context-menu
              [options]="{ width: '320px' }"
              [position]="'right-out'"
              [verticalPosition]="'auto-in'"
              #sortingMenu
              contextHoverIdentifier="section-{{ section().id }}"
            >
              <button
                appButton
                name="sorting"
                location="assets-section"
                [iconButton]="true"
                height="1"
                shape="round"
                contextButton
                appTooltip="Update Order"
                toolTipOrigin="left"
                color="simple"
              >
                <app-svg src="/assets/icons/arrow-sorting.svg"></app-svg>
              </button>
              <div contextContent class="sorting-menu">
                <h3 class="menu-list-title">ASSET ORDER</h3>
                @if (sortingMenu.isOpen()) {
                  @for (sort of sortings; track sort) {
                    @if (
                      !sort.endsWith('capture_time') || sorting.endsWith('capture_time') || someItemsHaveCaptureTime()
                    ) {
                      <div class="sort-button-container">
                        <button
                          appButton
                          [color]="sorting.split('|')[0].endsWith(sort) ? 'simple-primary' : 'hard-simple'"
                          class="align-left"
                          spacing="1-5"
                          height="1"
                          name="sorting-{{ sort }}"
                          location="assets-section"
                          (click)="changeAssetSorting(sort)"
                        >
                          {{ 'sorting_' + sort.split('|')[0].replace('-', '') | translate }}
                        </button>
                        @if (sort === 'random' && sorting.startsWith('random')) {
                          <button
                            appButton
                            name="refresh-randomize"
                            location="assets-section"
                            (click)="refreshRandom()"
                            color="simple-primary"
                            [iconButton]="true"
                            class="inner-sorting-button"
                            height="1"
                          >
                            <app-svg src="/assets/icons/arrow-swap.svg"></app-svg>
                          </button>
                        }

                        @if (sort !== 'random' && sort !== 'manual' && sorting.endsWith(sort)) {
                          <button
                            appButton
                            name="flip-sorting"
                            location="assets-section"
                            (click)="flipSorting()"
                            color="simple-primary"
                            [iconButton]="true"
                            class="inner-sorting-button"
                            [class.flippped]="sorting[0] === '-'"
                            height="1"
                          >
                            <app-svg src="/assets/icons/arrow-up.svg"></app-svg>
                          </button>
                        }
                      </div>
                    }
                  }
                  @if (sorting.endsWith('capture_time') && notAllItemsHaveCaptureTime()) {
                    <div class="divider drag-and-drop-info-spacer"></div>
                    <p class="info-message drag-and-drop-info">
                      <app-svg src="/assets/icons/16/info.svg"></app-svg>
                      <span>Some assets don’t have a capture time set.</span>
                    </p>
                  }
                }
              </div>
            </app-context-menu>
          </div>
        } @else {
          <app-context-menu
            [options]="{ width: '320px', noSpacing: true }"
            #menu
            contextHoverIdentifier="section-{{ section().id }}"
          >
            <button
              appButton
              name="settings"
              location="assets-section"
              color="simple"
              height="1"
              fullWidth="true"
              [hasIcon]="true"
              contextButton
            >
              <app-svg src="/assets/icons/mixer.svg"></app-svg>
              <span>Options</span>
            </button>
            <div contextContent>
              @if (menu.isOpen()) {
                <app-assets-section-menu
                  [section]="section()"
                  [gallery]="gallery()"
                  [theme]="theme()"
                  (onUpdateLayout)="calculateAllItemPositions()"
                  (onBeforeChange)="beforeSettingsChange()"
                >
                </app-assets-section-menu>
              }
            </div>
          </app-context-menu>
          <app-context-menu
            [options]="{ width: '320px' }"
            #sortingMenu
            contextHoverIdentifier="section-{{ section().id }}"
          >
            <button
              appButton
              name="sorting"
              location="assets-section"
              height="1"
              fullWidth="true"
              [hasIcon]="true"
              contextButton
              color="simple"
            >
              <app-svg src="/assets/icons/arrow-sorting.svg"></app-svg>
              <span>Order</span>
            </button>
            <div contextContent class="sorting-menu">
              <h3 class="menu-list-title">ASSET ORDER</h3>
              @for (sort of sortings; track sort) {
                @if (sort !== 'manual' || sorting === 'manual') {
                  <button
                    appButton
                    [color]="sorting === sort ? 'simple-primary' : 'hard-simple'"
                    class="align-left"
                    spacing="1-5"
                    height="1"
                    name="sorting-{{ sort }}"
                    location="assets-section"
                    (click)="changeAssetSorting(sort); sortingMenu.close()"
                  >
                    {{ 'sorting_' + sort | translate }}
                  </button>
                }
              }
              @if (sorting !== 'manual') {
                <div class="divider drag-and-drop-info-spacer"></div>
                <p class="info-message drag-and-drop-info">
                  <app-svg src="/assets/icons/16/info.svg"></app-svg>
                  <span>Drag assets for manual ordering.</span>
                </p>
              }
            </div>
          </app-context-menu>
        }
      </ng-container>
      <ng-container sectionContent>
        <div #sectionContent [class.dark]="darkBackground()">
          @if (items && !items.length && !fakeItems?.length && !forceAssetsView && galleryPermissions().can_edit) {
            <div class="page no-assets-page">
              <div class="no-assets-fake-assets">
                <div class="fake-asset-column">
                  <div class="no-asset-fake-asset"></div>
                  <div class="no-asset-fake-asset"></div>
                  <div class="no-asset-fake-asset"></div>
                </div>
                <div class="fake-asset-column">
                  <div class="no-asset-fake-asset short"></div>
                  <div class="no-asset-fake-asset long"></div>
                  <div class="no-asset-fake-asset"></div>
                </div>
                <div class="fake-asset-column">
                  <div class="no-asset-fake-asset long"></div>
                  <div class="no-asset-fake-asset"></div>
                  <div class="no-asset-fake-asset"></div>
                </div>
                <div class="fake-asset-column">
                  <div class="no-asset-fake-asset short"></div>
                  <div class="no-asset-fake-asset short"></div>
                  <div class="no-asset-fake-asset"></div>
                </div>
              </div>
              <div class="no-gallery-assets">
                <div class="halo"></div>
                <label for="{{ uploadIdPrefix }}asset-upload">
                  <img
                    [attr.data-picflow-hide]="true"
                    src="/assets/icons/special/image-stack-upload-{{ darkBackground() ? 'light' : 'dark' }}.svg"
                    class="upload-icon"
                    alt=""
                  />
                </label>
                @if (isDesktop) {
                  <h2>Upload Media</h2>
                  <div class="drop-assets-text-with-button">
                    <span>Drop or</span>
                    <app-context-menu
                      [options]="{ width: '240px', noSpacing: true }"
                      #sourceMenu
                      contextHoverIdentifier="section-{{ section().id }}"
                    >
                      <button
                        appButton
                        name="select-source"
                        location="assets-section"
                        color="simple-primary-opacity"
                        height="0"
                        spacing="1"
                        shape="small"
                        contextButton
                      >
                        Select Source
                      </button>

                      <div contextContent class="button-menu">
                        <app-upload-source-menu
                          [uploadIdPrefix]="uploadIdPrefix"
                          [sectionId]="section().id"
                          (onClose)="sourceMenu.close()"
                          (onUpload)="uploadAssets($event)"
                        ></app-upload-source-menu>
                      </div>
                    </app-context-menu>
                  </div>
                } @else {
                  <div class="drop-assets-text-with-button">
                    <label
                      appButton
                      name="select-assets"
                      location="assets-section"
                      weight="bold"
                      color="primary"
                      shape="round"
                      for="{{ uploadIdPrefix }}asset-upload"
                      >Upload Media</label
                    >
                  </div>
                }
              </div>
            </div>
          }
          @if (!items && !fakeItems) {
            <div class="loading-page page" [style.height]="sectionHeight + 'px'"></div>
          }
          @if (items?.length || fakeItems?.length || forceAssetsView) {
            <div
              class="gallery-asset-container"
              [class.no-animation]="noGalleryAnimation"
              [style.maxWidth]="sectionWidth() + 'px'"
              [class.force-open]="forceAssetsView"
              [class.debug]="debugMode"
              #assetGallery
            >
              @if (draggingItem) {
                <div
                  class="dragged-asset"
                  [style.left]="-mousePosOffsetX + 'px'"
                  [style.top]="-mousePosOffsetY + 'px'"
                  [style.transform]="'translate(' + mousePosX + 'px,' + mousePosY + 'px) translateZ(0)'"
                  [class.dragging]="dragging"
                  [class.hover-over-gallery]="draggingItemDropOnSubGallery"
                >
                  @if (draggingItem.asset | canDisplayAsset) {
                    @let imgSrc =
                      draggingItem.asset.version_data
                        | assetVersionUrl
                          : draggingItem.asset.version_data.uuid
                          : draggingItem.asset.version_data['status']
                          : draggingItem.asset.version_data.watermark_uuid
                          : draggingItem.dimensions.width
                          : true
                          : draggingItem.asset.watermark_enabled;
                    <img
                      [attr.data-picflow-hide]="true"
                      [src]="assetPreview[draggingItem.asset.version_data.asset_name]?.src || imgSrc"
                      [style.width]="draggingItem.dimensions.width + 'px'"
                      [style.height]="draggingItem.dimensions.height + 'px'"
                      alt=""
                    />
                  } @else {
                    <app-non-preview-file
                      [asset]="draggingItem.asset"
                      [gallery]="gallery()"
                      [style.width]="draggingItem.dimensions.width + 'px!important'"
                      [style.height]="draggingItem.dimensions.height + 'px!important'"
                    ></app-non-preview-file>
                  }
                  @if (draggingItemDropOnSubGallery) {
                    <app-svg class="drop-on-subgallery" src="/assets/icons/folder-forward.svg"></app-svg>
                  }
                </div>
              }
              <div
                class="gallery-assets {{ section().grid_layout ?? theme().section.grid_layout }}"
                [style.height]="sectionHeight + 'px'"
                [class.no-animation]="noGalleryAnimation"
              >
                @if (debugMode) {
                  @if (deadZone) {
                    <div
                      class="dead-zone"
                      [style.left]="deadZone.x + 'px'"
                      [style.top]="deadZone.y + 'px'"
                      [style.width]="deadZone.width + 'px'"
                      [style.height]="deadZone.height + 'px'"
                    ></div>
                  }
                  @for (item of visibleItems; track item.asset.id) {
                    <div
                      class="asset-bounds"
                      [style.left]="item.bounds.x + 'px'"
                      [style.top]="item.bounds.y + 'px'"
                      [style.width]="item.bounds.width + 'px'"
                      [style.height]="item.bounds.height + 'px'"
                    ></div>
                  }
                  @for (item of visibleItems; track item.asset.id) {
                    <div
                      class="asset-debug-number-container"
                      [style.left]="item.bounds.x + 'px'"
                      [style.top]="item.bounds.y + 'px'"
                      [style.width]="item.bounds.width + 'px'"
                      [style.height]="item.bounds.height + 'px'"
                    >
                      <div class="asset-debug-number">
                        <div class="count">{{ item.asset.position }}</div>
                      </div>
                    </div>
                  }
                }
                @for (item of visibleItems; track item.id) {
                  <div
                    class="gallery-asset color-{{ item.color }}"
                    [class.rounded]="section().rounded_corners ?? theme().section.rounded_corners"
                    [class.with-bg]="
                      item.asset.type !== 'image' || !(item.asset.version_data.asset_name | assetSupportsTransparency)
                    "
                    (contextmenu)="assetRightClick(item.asset, $event)"
                    id="asset-{{ item.asset.id }}"
                    data-transition-to-page="true"
                    (mouseenter)="isDesktop && setHoverItem(item)"
                    (mouseleave)="isDesktop && setHoverItem(undefined)"
                    appInferredHover="asset-{{ item.asset.id }}"
                    (onInferredHoverChange)="setHoverContextOpenItem($event ? item : undefined, item)"
                    [style.width]="item.dimensions.width + 'px'"
                    [style.height]="item.dimensions.height + 'px'"
                    [style.left]="item.dimensions.x + 'px'"
                    [style.top]="item.dimensions.y + 'px'"
                    [class.hide]="item?.asset.id === draggingItem?.asset.id"
                    [style.zIndex]="lastDraggingItem === item ? 2 : undefined"
                    (mousedown)="grapItemMouse($event, item)"
                    appTransitionPreventor
                  >
                    @if (['completed', 'failed'].includes(item.asset.version_data.status)) {
                      @if (
                        item?.asset.id === hoverItem?.asset.id || item?.asset.id === hoverContextOpenItem?.asset.id
                      ) {
                        @if (galleryPermissions().can_edit) {
                          <div class="asset-menu-container" [@assetButton]>
                            <app-context-menu
                              [options]="{ noSpacing: true, width: '240px' }"
                              #menu
                              contextHoverIdentifier="asset-{{ item.asset.id }}"
                            >
                              <button
                                appButton
                                name="asset-context"
                                location="assets-section"
                                [iconButton]="true"
                                color="dark-blur"
                                shape="round"
                                height="-1"
                                contextButton
                                #button
                              >
                                <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
                              </button>
                              <div contextContent>
                                @if (
                                  contextService.onContextOpen | async | inferredContextOpen: 'asset-' + item.asset.id
                                ) {
                                  <app-asset-context-menu
                                    [asset]="item.asset"
                                    [galleryPermissions]="galleryPermissions()"
                                    [gallery]="gallery()"
                                    [autoplayShown]="true"
                                    [clientEl]="button"
                                    (onClose)="menu.close()"
                                    (onCoverChange)="onCoverChange.emit()"
                                    (openShare)="openShareDialog(item.asset)"
                                    (onNewVersion)="onNewVersion()"
                                    #assetContextMenu
                                  >
                                  </app-asset-context-menu>
                                }
                              </div>
                            </app-context-menu>
                          </div>
                        } @else if (item.asset | canDownloadAsset: gallery() : galleryPermissions()) {
                          <app-asset-download-button
                            [@assetButton]
                            location="assets-section"
                            [galleryPermissions]="galleryPermissions()"
                            [asset]="item.asset"
                            [gallery]="gallery()"
                            [previewWidth]="item.dimensions.width"
                            (click)="downloadClick($event)"
                          >
                            <button
                              appButton
                              name="download"
                              location="assets-section"
                              [iconButton]="true"
                              color="dark-blur"
                              shape="round"
                              height="-1"
                            >
                              <app-svg src="/assets/icons/download.svg"></app-svg>
                            </button>
                          </app-asset-download-button>
                        }
                      }
                      <a [routerLink]="item.asset.id" [queryParams]="assetQueryParams" fragment="comments">
                        <app-activity-badge
                          [asset]="item.asset"
                          [onlyDot]="hoverItem !== item"
                          [hideWhenEmpty]="true"
                          [hasLink]="true"
                          [customBorderColor]="
                            section().layout_background_color || theme().layout_page.background_color
                          "
                        >
                        </app-activity-badge>
                      </a>
                    }
                    <a
                      [routerLink]="item.asset['isFake'] ? undefined : item.asset.id"
                      [queryParams]="assetQueryParams"
                      class="asset-link"
                      [preserveFragment]="true"
                    >
                      <app-layout-asset
                        [asset]="item.asset"
                        [gallery]="gallery()"
                        [roundedCorners]="section().rounded_corners ?? theme().section.rounded_corners"
                        [hovering]="hoverItem === item || hoverContextOpenItem === item"
                        [isDesktop]="isDesktop"
                        [width]="item.dimensions.width"
                        [galleryPermissions]="galleryPermissions()"
                        [preview]="assetPreview[item.asset.version_data.asset_name]?.src"
                        [allowedAndEnabledFeedbackOptions]="allowedAndEnabledFeedbackOptions()"
                        [approvedAssetCount]="approvedAssetCount()"
                        [clientMode]="false"
                      ></app-layout-asset>
                    </a>
                    @if (section().show_filenames ?? theme().section.show_filenames) {
                      <div class="asset-name">
                        {{ item.asset.version_data.asset_name }}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
          @if (!isDesktop && galleryPermissions().can_edit && (items?.length || fakeItems?.length)) {
            <app-sticky
              [offsetBottom]="50"
              [paddingY]="-30"
              [container]="sectionContainer?.sectionContentInner?.nativeElement"
              stickTo="bottom"
              [fullWidth]="true"
            >
              <label
                appButton
                for="{{ uploadIdPrefix }}asset-upload"
                name="mobile-upload"
                location="assets-section"
                [hasIcon]="true"
                color="hard-simple"
                class="mobile-upload-button"
                height="1"
                weight="bold"
                shape="round"
                [center]="true"
              >
                <app-svg src="/assets/icons/upload.svg" size="0"></app-svg>
                <span>Upload</span>
              </label>
            </app-sticky>
          }
        </div>
      </ng-container>
    </app-section-container>
  </app-drop>
}
